import { useEffect } from 'react';
import { ClientStatus } from '../../../model/types/ClientStatus';

export default (status: ClientStatus): void => {
  const scrollIntoViewIfNeeded = (): void => {
    const clientErrorElements = document.getElementsByClassName('client-error-message');
    if (clientErrorElements.length > 0) {
      window.parent.postMessage({
        type: 'scroll-to',
        top: clientErrorElements[0].getBoundingClientRect().top,
      }, '*');
    }
    const idskErrorElements = document.querySelectorAll(
      '.idsk-message-error, .idsk-form-group--error, .idsk-error-message',
    );
    if (idskErrorElements.length > 0) {
      window.parent.postMessage({
        type: 'scroll-to',
        top: idskErrorElements[0].getBoundingClientRect().top,
      }, '*');
    }
  };

  useEffect(() => {
    if (status?.generalErrors.length || status?.fieldErrors.length || status?.responseCode === 500) {
      setTimeout(() => {
        scrollIntoViewIfNeeded();
      }, 100);
    }
  }, [status?.generalErrors, status?.fieldErrors, status?.responseCode]);
};
